export const PillarStatus = {
    ACTIVE: 'Active',
    DRAFT: 'Draft',
    INACTIVE: 'Inactive',
} as const;

export type PillarStatusType = (typeof PillarStatus)[keyof typeof PillarStatus];

/** Maximum number of pillars that may be Active at once; enforced server-side (409, `PillarActiveLimitReached`). */
export const PILLAR_ACTIVE_LIMIT = 20;

/** The `code` a 409 carries once `PILLAR_ACTIVE_LIMIT` is reached -- lives here (not in
 * `pillarErrors.ts`) so the MSW mock handlers can reference it without pulling in Toast/i18n. */
export const PILLAR_ACTIVE_LIMIT_ERROR_CODE = 'PillarActiveLimitReached';
